import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { Loader } from "@/shared/ui/loader"
import { NoTableData } from "@/shared/ui/no-table-data"
import { Table } from "@/shared/ui/table"
import { ColumnDef } from "@tanstack/react-table"
import { Pagination } from "@/shared/ui/pagination"
import { Link } from "react-router-dom"
import { IParticipation } from "@/shared/api/marketing-campaigns/types"
import { selectParticipations, selectParticipationsLoading, selectParticipationsPage, selectParticipationsTotalPages, setParticipationsPage } from "@/entities/marketing-campaign"
import { getDisplayName } from "@/entities/user"

export const ParticipationsTable = () => {
    const participations = useAppSelector(selectParticipations)
    const isLoading = useAppSelector(selectParticipationsLoading)
    const dispatch = useAppDispatch()
    const page = useAppSelector(selectParticipationsPage)
    const totalPages = useAppSelector(selectParticipationsTotalPages)

    const columns: ColumnDef<IParticipation, any>[] = [
        {
            accessorFn: (participation) => (
                <div>
                    {participation.user
                        ? <Link className="hover:cursor-pointer hover:underline text-color-primary font-semibold" to={`/users/profile/${participation.user.id}`}>{getDisplayName(participation.user)}</Link>
                        : "—"
                    }
                </div>
            ),
            id: 'user',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">Пользователь</div>,
        },
        {
            accessorFn: (participation) => (
                <div>
                    {participation.user?.username 
                        ? "@" + participation.user.username 
                        : participation.user?.telegram_id ?? "—"
                    }
                </div>
            ),
            id: 'username',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">Telegram Username</div>,
        },
        {
            accessorFn: (participation) => (
                <div>
                    {participation.user?.phone || "—"}
                </div>
            ),
            id: 'phone',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">Телефон</div>,
        },
    ]

    return (
        <>
            {Boolean(participations.length) &&
                <div className="table_box">
                    <div className="font-mediumttf text-xl px-2 py-2">
                        Участники
                    </div>
                    <Table columns={columns} data={participations} />
                    <Pagination 
                        page={page} 
                        totalPages={totalPages} 
                        setPage={(page) => dispatch(setParticipationsPage(page))}
                    />
                </div>
            }
            {(!Boolean(participations.length) && isLoading) &&
                <div className="info_panel">
                    <Loader />
                </div>
            }
            {(!Boolean(participations.length) && !isLoading) &&
                <NoTableData label="Нет данных об участниках" />
            }
        </>
    )
}